import React, {Component} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';

const useStyles = makeStyles((theme) => ({
    avatar: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.text.secundary
      },
      tituloCard: {
          fontWeight: '500',
          color: theme.palette.text.primary
      }
}));

function ComponentItem(pai) {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardActionArea >
            <CardHeader      
                title={
                    <Typography variant="body1" className={classes.tituloCard} >
                        {pai.props.title}
                    </Typography>
                }
                avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>          
                        <Icon>{pai.props.icone}</Icon> 
                    </Avatar>
                }
            />                
            </CardActionArea>
        </Card>
    );
}

export default class Item extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (<ComponentItem {...this}/>);
    }
}